import JiraIssueLink from '@databases/content-link/JiraIssueLink';
import { ViewComponentProps } from '@databases/fields/view/types';
import { DatabaseFieldType } from '@databases/types/database';
import { isNonEmptyJiraIssueValue } from '@databases/utils/database/field-types/jiraIssue';
import React, { FunctionComponent, useMemo } from 'react';
import styled from 'styled-components';

const Container = styled.ul`
  list-style-type: none;
  padding: 0;

  > li + li {
    margin-top: 5px;
  }
`;

const JiraIssueValueView: FunctionComponent<
  ViewComponentProps<DatabaseFieldType.JIRA_ISSUE>
> = ({ field, value }) => {
  const issues = useMemo(
    () =>
      value.flatMap((v) => {
        if (isNonEmptyJiraIssueValue(v)) {
          return [
            {
              _id: v._id,
              cloudId: field.settings.cloudId,
              serverId: field.settings.jiraServerId,
              key: v.key,
            },
          ];
        } else {
          return [];
        }
      }),
    [field.settings.cloudId, field.settings.jiraServerId, value]
  );

  return (
    <Container>
      {issues.map((issue) => (
        <li key={issue._id}>
          <JiraIssueLink issue={issue} useSmartLink />
        </li>
      ))}
    </Container>
  );
};

export default JiraIssueValueView;
